import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * @description
 * Expone las site keys de reCAPTCHA (públicas) configuradas por entorno vía
 * `environment.ts`/`environment.dev.ts`/`environment.qa.ts`/`environment.prod.ts`.
 * No expone ni conoce la secret key: esa nunca debe vivir en el frontend.
 */
@Injectable({
  providedIn: 'root',
})
export class RecaptchaConfigService {
  /** Site key de reCAPTCHA v2, usada solo si se habilita el widget de checkbox. */
  readonly recaptchaSiteKeyV2: string = environment.RECAPTCHA_SITE_KEY_V2;

  /** Site key de reCAPTCHA v3, usada por la ejecución invisible en el login. */
  readonly recaptchaSiteKeyV3: string = environment.RECAPTCHA_SITE_KEY_V3;
}
